import { ColumnLayout, RowLayout } from 'ui/common/layout'
import { TouchableOpacity, View } from 'react-native'
import { Image } from 'ui/common/image'
import { OverLine } from 'ui/common/text'
import React from 'react'
import { Place, PlacePreference, PlacePreferenceNonNull } from 'infra/type'
import { observer } from 'mobx-react'
import { getPreferenceImage } from 'image/preference'
import { rgba } from 'polished'
import { colors } from 'infra/color.ts'
import { placesStore } from 'store/places.ts'
import { setPreference } from 'api/writes.ts'
import { alert } from 'infra/util.ts'

const PreferenceButton: React.FC<{
  target: PlacePreferenceNonNull
  current: PlacePreference
  onPress: (v: PlacePreferenceNonNull) => void
}> = ({ target, current, onPress }) => {
  return (
    <TouchableOpacity
      style={{ paddingHorizontal: 4, paddingVertical: 8 }}
      onPress={() => onPress(target)}
    >
      <ColumnLayout style={{ alignItems: 'center', gap: 4 }}>
        <Image
          source={getPreferenceImage(target, target !== current)}
          style={{
            width: 16,
            height: 16,
          }}
        />
        <OverLine>
          {
            {
              WANT: '가볼래요',
              LIKED: '좋았어요',
              AVOID: '추천안함',
            }[target]
          }
        </OverLine>
      </ColumnLayout>
    </TouchableOpacity>
  )
}

export const PreferenceButtonArea: React.FC<{
  data: Place
  isNavigationBar?: boolean
}> = observer(({ data, isNavigationBar }) => {
  const onPress = async (v: PlacePreferenceNonNull) => {
    const prevPreference = data.preference
    // 같은 걸 두번 누르면 원래대로 돌아오기
    const nextPreference = prevPreference === v ? null : v
    try {
      placesStore.updatePreference(data.id, nextPreference)
      await setPreference(data.id, nextPreference)
    } catch {
      placesStore.updatePreference(data.id, prevPreference)
      alert('관심 북마크에 실패했습니다!')
    }
  }
  return (
    <RowLayout style={{ alignItems: 'center', gap: 2 }}>
      <PreferenceButton
        target='WANT'
        current={data.preference}
        onPress={onPress}
      />
      <PreferenceButton
        target='LIKED'
        current={data.preference}
        onPress={onPress}
      />
      {!isNavigationBar && (
        <View
          style={{
            width: 1,
            height: '70%',
            marginHorizontal: 4,
            backgroundColor: rgba(colors.black, 0.05),
          }}
        />
      )}
      <PreferenceButton
        target='AVOID'
        current={data.preference}
        onPress={onPress}
      />
    </RowLayout>
  )
})
